import React from 'react'
import {
    Breadcrumb,
    Button,
    Card,
    Checkbox,
    Col,
    Divider,
    Drawer,
    Dropdown,
    Flex,
    Form,
    Input,
    Layout,
    message,
    Popconfirm,
    Radio,
    Row,
    Select,
    Steps,
    Table,
    Tag,
    theme,
    Tour,
    Typography,
} from 'antd';
import {
    FilterOutlined,
    HomeOutlined,
    CopyOutlined,
    DeleteOutlined,
    EyeOutlined,
    EditOutlined,
    FileWordOutlined,
    AppstoreOutlined,
    MoreOutlined,
} from '@ant-design/icons';

export default function Frontend() {

    const innerhtml = `
    <div class="ant-row css-dev-only-do-not-override-11lehqq" style="margin-bottom:16px;position:relative"><div style="border:1px dashed #424242;padding:4px;min-height:60px;position:relative" class="ant-col ant-col-24 css-dev-only-do-not-override-11lehqq"><div class="ant-form-item css-dev-only-do-not-override-11lehqq" style="margin:10px"><div class="ant-row ant-form-item-row css-dev-only-do-not-override-11lehqq"><div class="ant-col ant-form-item-control css-dev-only-do-not-override-11lehqq"><div class="ant-form-item-control-input"><div class="ant-form-item-control-input-content"><input placeholder="Enter title here" id="title-0-0" class="ant-input css-dev-only-do-not-override-11lehqq ant-input-outlined" type="text" value=""/></div></div></div></div></div></div></div><div class="ant-row css-dev-only-do-not-override-11lehqq" style="margin-bottom:16px;position:relative"><div style="border:1px dashed #424242;padding:4px;min-height:60px;position:relative" class="ant-col ant-col-12 css-dev-only-do-not-override-11lehqq"><div style="flex:1;padding:10px;position:relative;margin-top:16px"><div contenteditable="true" style="border:1px solid #d9d9d9;border-radius:8px;min-height:100px;padding:16px;overflow-y:auto"></div></div></div><div style="border:1px dashed #424242;padding:4px;min-height:60px;position:relative" class="ant-col ant-col-12 css-dev-only-do-not-override-11lehqq"><div style="flex:1;padding:10px;position:relative;margin-top:16px"><div contenteditable="true" style="border:1px solid #d9d9d9;border-radius:8px;min-height:100px;padding:16px;overflow-y:auto"></div></div></div></div>
    `;
  return (
    <>
    <div
        dangerouslySetInnerHTML={{ __html: innerhtml }}
      
        
    ></div>
    
    </>
  )
}
